import { useState } from 'react'
import { X } from 'lucide-react'

interface MissedDoseModalProps {
  medicationName: string
  petName: string
  onConfirm: (instructions: string) => void
  onCancel: () => void
  isLoading?: boolean
}

const MIN_INSTRUCTIONS_LENGTH = 10

export function MissedDoseModal({
  medicationName,
  petName,
  onConfirm,
  onCancel,
  isLoading = false,
}: MissedDoseModalProps) {
  const [instructions, setInstructions] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)

    const trimmed = instructions.trim()
    if (trimmed.length < MIN_INSTRUCTIONS_LENGTH) {
      setError(`Las instrucciones deben tener al menos ${MIN_INSTRUCTIONS_LENGTH} caracteres`)
      return
    }

    onConfirm(trimmed)
  }

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal missed-dose-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Dosis Omitida</h3>
          <button type="button" className="modal-close" onClick={onCancel}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p className="missed-dose-info">
              <strong>{medicationName}</strong> para <strong>{petName}</strong>
            </p>

            <div className="form-group">
              <label htmlFor="instructions">
                Instrucciones <span className="required">*</span>
              </label>
              <textarea
                id="instructions"
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
                placeholder="Ej: Mascota rechazó la comida, se dará con la siguiente comida"
                rows={4}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                autoFocus
              />
              {error && <div className="invalid-feedback">{error}</div>}
              <small className="form-help">
                Mínimo {MIN_INSTRUCTIONS_LENGTH} caracteres. Explica por qué se omitió y qué acción tomar.
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-warning"
              disabled={isLoading || instructions.trim().length < MIN_INSTRUCTIONS_LENGTH}
            >
              {isLoading ? 'Guardando...' : 'Confirmar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
